import { Note } from '@teetsh/app/src/containers/CarnetsDeNotes/types/carnetsDeNotes';
import { RefObject, createRef, useEffect, useState } from 'react';

export function useNoteRefs(notes: Note[]) {
  const [refs, setRefs] = useState<{
    [key: string]: RefObject<HTMLDivElement>;
  }>({});

  useEffect(() => {
    const newRefs = notes.reduce((acc, note) => {
      acc[note.id] = createRef();
      return acc;
    }, {});
    setRefs(newRefs);
  }, [notes]);

  return {
    getInputRef: (noteId: string) => refs[noteId],
    getNextInputRef: (noteId: string) => {
      const index = notes.findIndex(note => note.id === noteId);
      const nextIndex = index + 1;
      if (nextIndex >= notes.length) {
        return refs[notes[0].id];
      }
      return refs[notes[nextIndex].id];
    },
  };
}
